const spacings = {
  topBottomSpacing: 50,
  topBottomSpacingMobile: 30,
  topBottomSpacingMobileCta: 130,
  leftRightSpacing: 80,
  leftRightSpacingMobile: 20,
  leftRightSpacingMobileReview: 0,
  topBottomSpacingEasy: 40,
  topBottomSpacingCTA: 100,
  topBottomCtaButton: 10,
  leftRightCtaButton: 20,
};

export default spacings;
